import { useSelector } from 'react-redux';
import { RootState } from '..';

export const useOnboardedSuppliers = (): RootState => useSelector((store: RootState) => store.suppliersReducer);
